import media from "../../../utils/media";
import styled from "styled-components";

export const StyledHeaderContainer = styled.div`
  background: ${({ theme }) =>
    theme.darkMode ? theme.computedPrimary : theme.primary};
  padding: 0px;
  box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.2);
  margin-bottom: 8px;
  ${media.desktop`
    padding: 24px 0;
    z-index: 10;
  `};
`;

export const StyledHeader = styled.div`
  color: ${props => props.theme.textSecondaryOnPrimary};
  height: 0px;
  transition: height 0.2s ease;
  visibility: collapse;

  ${media.desktop`
    height: inherit;
    transition: none;
    visibility: inherit;
    display: flex;
    flex-direction: ${props =>
      props.theme.scriptDirection === "rtl" ? "row-reverse" : "row"};
    position: relative;
    width: ${props => (props.hasParallels ? "86%" : "80%")};
    max-width: ${props => (props.hasParallels ? "86%" : "800px")};
    margin: 0px auto 0px;
    vertical-align: middle;
    align-content: center;
    opacity: ${props => props.opacity};

    a {
      color: ${props => props.theme.textSecondaryOnPrimary};
      text-decoration: none;
    }
  `};
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  flex-direction: ${props =>
    props.theme.scriptDirection === "rtl" ? "row-reverse" : "row"};
`;

export const IconContainer = styled.div`
  display: flex;
  flex-direction: ${props =>
    props.theme.scriptDirection === "rtl" ? "row-reverse" : "row"};
`;

export const Title = styled.h1`
  padding: 0;
  font-weight: 400;
  font-size: 1.6em;
  display: inline-block;
  letter-spacing: 0.05em;
  flex: 2;
  position: relative;
  margin: 0;
  text-align: ${props =>
    props.theme.scriptDirection === "rtl" ? "right" : "left"};
`;

export const LogoContainer = styled.div`
  justify-content: ${props =>
    props.theme.scriptDirection === "rtl" ? "flex-start" : "flex-end"};
  display: flex;
  align-items: top;

  img {
    height: 50px;
    max-width: 120px;

    ${media.tablet`
      height: 70px;
      max-width: 140px;
    `};

    ${media.desktop`
      height: 80px;
      max-width: 260px; 
    `};
  }

  img.default-logo {
    padding: 0 8px;
    width: 30px;
    height: 30px;
  }
`;
